//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    cssClasses: function cssClasses() {
      // TODO: Remove this after migrating to `panels/responsive`
      // Vertical panels are nameless when used in predefined layout (e.g. page.body, list.header, etc.)
      this.spec.view = this.spec.view || "panels/vertical";
      var classes = this.$classes().concat("layouts-vertical");

      switch (this.spec.distribution) {
        case "fillEqually":
          classes.push("layouts-vertical--fill-equally");
          break;

        case "spaceEqually":
          classes.push("layouts-vertical--space-equally");
          break;
      }

      return classes;
    },
    cssStyles: function cssStyles() {
      var styles = this.genericStyles();

      switch (this.spec.align) {
        case "center":
          styles["align-items"] = "center";
          break;

        case "right":
          styles["align-items"] = "flex-end";
          break;

        default:
          styles["align-items"] = "flex-start";
      }

      return styles;
    },
    componentName: function componentName() {
      return this.$href() ? "a" : "div";
    }
  }
};